import React from "react";

const MentorCard = ({ mentor }) => {
  const {
    image,
    name,
    badge,
    title,
    bio,
    ieltsScore,
    students,
    skills,
    imageZoom = 1,
    imageZoomTablet,
    imageZoomMobile,
    imagePositionX = "center",
    imagePositionXTablet,
    imagePositionXMobile,
    imagePositionY = "center",
    imagePositionYTablet,
    imagePositionYMobile,
  } = mentor;

  const normalizeSkill = (skill) => {
    if (typeof skill === "string") {
      return {
        label: skill,
        bgClass: "bg-[#eef0f4]",
        textClass: "text-[#3f3a33]",
      };
    }

    return {
      label: skill.label,
      bgClass: skill.bgClass || "bg-[#eef0f4]",
      textClass: skill.textClass || "text-[#3f3a33]",
    };
  };

  return (
    <article className="st-aboutus-mentor-card flex h-full flex-col overflow-hidden rounded-[22px]">
      <div className="st-aboutus-mentor-media relative h-[250px] overflow-hidden rounded-t-[22px] bg-[#f5efe4] sm:h-[270px] lg:h-[280px]">
        <img
          src={image}
          alt={name}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover scale-[var(--mentor-scale-mobile)] md:scale-[var(--mentor-scale-tablet)] lg:scale-[var(--mentor-scale-desktop)] [object-position:var(--mentor-pos-x-mobile)_var(--mentor-pos-y-mobile)] md:[object-position:var(--mentor-pos-x-tablet)_var(--mentor-pos-y-tablet)] lg:[object-position:var(--mentor-pos-x-desktop)_var(--mentor-pos-y-desktop)]"
          style={{
            "--mentor-scale-mobile": imageZoomMobile ?? imageZoom,
            "--mentor-scale-tablet": imageZoomTablet ?? imageZoom,
            "--mentor-scale-desktop": imageZoom,
            "--mentor-pos-x-mobile": imagePositionXMobile ?? imagePositionX,
            "--mentor-pos-x-tablet": imagePositionXTablet ?? imagePositionX,
            "--mentor-pos-x-desktop": imagePositionX,
            "--mentor-pos-y-mobile": imagePositionYMobile ?? imagePositionY,
            "--mentor-pos-y-tablet": imagePositionYTablet ?? imagePositionY,
            "--mentor-pos-y-desktop": imagePositionY,
            transformOrigin: "center center",
          }}
        />

        <span className="st-aboutus-mentor-badge absolute right-3 top-3 rounded-full px-3 py-1 text-[10px] font-semibold tracking-[0.12em] sm:right-4 sm:top-4 sm:px-3.5 sm:py-1.5 sm:text-[11px]">
          {badge}
        </span>
      </div>

      <div className="flex flex-1 flex-col border-t border-[#ece8df] bg-white px-5 pb-5 pt-5 sm:px-6 sm:pb-6 sm:pt-6">
        <div>
          <h3 className="st-aboutus-mentor-name st-font-body text-[17px] font-bold leading-[1.2] text-[#151515] sm:text-[19px] lg:text-[20px]">
            {name}
          </h3>
          <p className="st-aboutus-mentor-role mt-2 text-[11px] font-bold uppercase leading-[1.4] tracking-[0.12em] sm:text-[12px] lg:text-[13px]">
            {title}
          </p>
          <p className="st-aboutus-mentor-bio st-font-body mt-4 text-[13px] leading-[1.65] sm:text-[14px] lg:text-[15px]">
            {bio}
          </p>
        </div>

        <div className="mt-5 grid grid-cols-2 gap-3 sm:mt-6">
          <div className="st-aboutus-mentor-metric rounded-[14px] px-3 py-3 text-center sm:px-4 sm:py-3.5">
            <div className="st-aboutus-mentor-metric-value text-[16px] font-bold leading-none text-[#1f1f1f] sm:text-[18px] lg:text-[20px]">
              {ieltsScore}
            </div>
            <div className="st-aboutus-mentor-metric-label mt-1 text-[9px] font-semibold uppercase tracking-[0.16em] sm:text-[10px]">
              IELTS SCORE
            </div>
          </div>

          <div className="st-aboutus-mentor-metric rounded-[14px] px-3 py-3 text-center sm:px-4 sm:py-3.5">
            <div className="st-aboutus-mentor-metric-value text-[16px] font-bold leading-none text-[#1f1f1f] sm:text-[18px] lg:text-[20px]">
              {students}
            </div>
            <div className="st-aboutus-mentor-metric-label mt-1 text-[9px] font-semibold uppercase tracking-[0.16em] sm:text-[10px]">
              SISWA DIBIMBING
            </div>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap gap-2 sm:mt-6">
          {skills.map((skill) => {
            const normalizedSkill = normalizeSkill(skill);

            return (
              <span
                key={normalizedSkill.label}
                className={`inline-flex items-center rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-[0.08em] sm:text-[11px] ${normalizedSkill.bgClass} ${normalizedSkill.textClass}`}
              >
                {normalizedSkill.label}
              </span>
            );
          })}
        </div>
      </div>
    </article>
  );
};

export default MentorCard;
